module.exports = __webpack_public_path__ + "img/filters.ce36bcb9.svg";